import { IconButton as MuiIconButton, IconButtonProps as MuiIconButtonProps, SxProps, Theme, Tooltip } from '@mui/material';
import React from 'react';

interface IconButtonProps extends Omit<MuiIconButtonProps, 'variant'> {
  contained?: boolean;
  sx?: SxProps<Theme>;
  tooltip?: string;
}

const IconButton: React.FC<IconButtonProps> = ({
  contained = false,
  sx,
  tooltip,
  disabled,
  ...props
}) => {
  const containedStyles: SxProps<Theme> = contained ? {
    color: 'primary.main',
    borderRadius: '50%',
    backgroundColor: (theme) => theme.palette.primary.light + '66', // 40% opacity
    '&:hover': {
      backgroundColor: 'primary.light', // 55% opacity
    }
  } : {
    color: 'text.primary',
  };

  const button = (
    <MuiIconButton
      {...props}
      disabled={disabled}
      sx={{
        ...containedStyles,
        ...sx,
      }}
    />
  );

  // If no tooltip provided, return button as-is
  if (!tooltip) {
    return button;
  }

  // If button is disabled, wrap in span so tooltip works (MUI requirement)
  if (disabled) {
    return (
      <Tooltip title={tooltip} arrow>
        <span>{button}</span>
      </Tooltip>
    );
  }

  // Normal case: wrap button with tooltip
  return (
    <Tooltip title={tooltip} arrow>
      {button}
    </Tooltip>
  );
};

export default IconButton; 